module.exports = __webpack_public_path__ + "img/icon-tooltip.e9eb67af.svg";